import { getResizedImage } from 'shared-helpers/common';
import { getMessageWithPlaceholders } from 'shared-locales';
import { useReduxState } from 'hooks';
import { useApiData } from 'lib/api';
import {
  LoadingIndicator,
  Owners,
  PublishedProductText
} from 'components/common';
import { HomeDetailsItem } from '.';

import type { GetUnreviewedAnswersRes } from 'shared-types/responses';

const HomeDetailsUnreviewedAnswers = () => {
  const { messages, theme, user } = useReduxState();

  const { data, loading } = useApiData<GetUnreviewedAnswersRes>({
    onlyIf: Boolean(user?.id),
    url: '/admin/unreviewed-answers'
  });

  return loading ? (
    <LoadingIndicator />
  ) : (
    <div className="courses">
      {data?.unreviewedAnswers.map((course) => (
        <HomeDetailsItem
          href={`/admin/courses/${course.slug}/follow/tasks`}
          key={course.id}
          category="default"
          text={getMessageWithPlaceholders({
            message: messages.adminCountUnreviewedAnswers,
            placeholders: { number: course.numberOfUnreviewedAnswers }
          })}
        >
          <div
            className="course-picture"
            style={{
              backgroundImage: `url(${getResizedImage({
                url: course.picture,
                size: 480
              })})`,
              backgroundPosition: course.picturePosition
            }}
          />

          <div className="inner">
            <div className="title">{course.title}</div>
            <div className="info">
              <Owners owners={course.owners} />

              <PublishedProductText
                endDate={course.endDate as string}
                startDate={course.startDate as string}
              />
            </div>
          </div>
        </HomeDetailsItem>
      ))}

      <style jsx>{`
        .courses {
          display: flex;
          flex-direction: column;
          gap: 15px;
        }
        .course-picture {
          background-color: ${theme.lightGrey};
          background-size: cover;
          border-radius: 8px;
          flex-shrink: 0;
          height: 40px;
          width: 40px;
        }
        .inner {
          flex-grow: 1;
        }
        .title {
          font-size: 1.6rem;
          font-weight: 700;
        }
        .info {
          color: ${theme.textColorLighter};
          display: flex;
          flex-wrap: wrap;
          font-size: 1.4rem;
          font-weight: 600;
          gap: 5px 40px;
          margin-top: 4px;
        }
      `}</style>
    </div>
  );
};

export default HomeDetailsUnreviewedAnswers;
